import { render } from "./HomeNavbar.vue?vue&type=template&id=16daf029"
const script = {}

import "./HomeNavbar.vue?vue&type=style&index=0&id=16daf029&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__